export const environment = {
  production: true,
  baseUserServiceUrl: 'https://a.tangent.ai/',
  baseGeoServiceUrl: 'https://a.tangent.ai/'
};
